module.exports = new __parcel__URL__("logo_wc.95babd66.png").toString();